import { memo, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { getShipmentDefaultFilters } from '../../../contants/ShipmentEnums';
import { setAppLoader } from '../../../redux/common/CommonActions';
import {
  copyShipmentInProgress,
  getSearchQuoteListInProgress,
  setSearchQuoteFilters,
  setSelectedShipments,
  setShipmentFilters,
  setShipmentList,
} from '../../../redux/shipment/ShipmentActions';
import EmptyRecords from '../../components/Common/EmptyRecords';
import Paper from '../../components/Paper/Paper';
import ContentSpinner from '../../components/Spinners/ContentSpinner';
import QuoteList from './QuoteList';

const QuoteContent = () => {
  const dispatch = useDispatch();
  const selectedShipments = useSelector((state) => state.shipment.selectedShipments, shallowEqual);
  const quoteSearchList = useSelector((state) => state.shipment.quoteSearchList);
  const searchQuoteFilters = useSelector((state) => state.shipment.searchQuoteFilters, shallowEqual);

  const companyId = useSelector((state) => state.auth.selectedCompany.companyId, shallowEqual);
  const { appLoader } = useSelector((state) => state.common);

  const userId = useSelector((state) => state.auth.user.data?.id, shallowEqual) || 0;

  const onSelect = (id, remove) => {
    const selectedShipmentsLocal = [...selectedShipments];
    if (!remove) {
      selectedShipmentsLocal.push(id);
    } else {
      const index = selectedShipmentsLocal.indexOf(id);
      selectedShipmentsLocal.splice(index, 1);
    }
    dispatch(setSelectedShipments(selectedShipmentsLocal));
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO: refactor to react-query
  useEffect(() => {
    if (companyId) {
      dispatch(setSelectedShipments([]));
      dispatch(
        setShipmentFilters({
          ...getShipmentDefaultFilters(),
          PageNumber: 1,
        }),
      );
      dispatch(
        setShipmentList({
          data: [],
          isFirstTime: true,
          latedelivery: 0,
          latepickup: 0,
          missingDocument: 0,
          pickupFailed: 0,
          progressing: true,
          totalRecords: 0,
          trackingfailures: 0,
        }),
      );
    }
  }, [companyId]);

  const handleCopy = (shipmentKey, InterNationalTransload) => {
    const { shipmentNo, approvalNumber } =
      quoteSearchList?.data?.find((item) => item.shipmentKey === shipmentKey) || {};
    const payload = {
      InterNationalTransload,
      OldShipmentKey: shipmentKey,
      oldApprovalNumber: approvalNumber,
      oldShipmentNumber: shipmentNo,
      UserId: userId,
    };
    dispatch(setAppLoader(true));
    dispatch(copyShipmentInProgress(payload));
  };

  const handleNextPage = () => {
    dispatch(
      setSearchQuoteFilters({
        ...searchQuoteFilters,
        pageNumber: searchQuoteFilters.pageNumber + 1,
      }),
    );
    dispatch(getSearchQuoteListInProgress());
  };

  const hasMore =
    quoteSearchList?.spotBidsData?.length >
    (quoteSearchList?.totals?.find((total) => total.totalAreaName === 'TotalRecords')?.count || 0);

  return (
    <div className="h-100 d-flex flex-direction-column mt-15" data-testid="search-quote-content-table">
      {quoteSearchList.isFirstTime ? (
        <Paper className="h-100 w-100 mb-15" />
      ) : quoteSearchList.data && quoteSearchList.data.length > 0 ? (
        <QuoteList
          shipmentList={quoteSearchList.data}
          onSelect={onSelect}
          selectedShipments={selectedShipments}
          handleCopy={handleCopy}
          isLoading={quoteSearchList.progressing}
          handleNextPage={handleNextPage}
          hasMore={hasMore}
        />
      ) : quoteSearchList.progressing || appLoader ? (
        <ContentSpinner size="large" />
      ) : (
        <EmptyRecords className="mb-15" />
      )}
    </div>
  );
};

export default memo(QuoteContent);
